import { onMounted } from 'vue';
import { useNotificationForm } from './useNotificationForm';
import { notificationApi } from '../api/notification.api';

export type { PeriodicityMode } from './useNotificationForm';

export function useCreateNotification(emit: (event: string, ...args: unknown[]) => void) {
  const form = useNotificationForm(emit);

  onMounted(() => form.fetchPositionsAndUsers());

  const handleSave = async () => {
    if (!form.isFormValid.value || form.isSaving.value) return;

    form.isSaving.value = true;
    try {
      await notificationApi.createNotification(form.buildPayload(false));
      form.toast.showSuccessToast({ title: 'Notificação criada com sucesso', type: 'success' });
      emit('notification-created');
      form.handleClose();
    } catch {
      form.toast.showErrorToast({ title: 'Erro ao criar notificação', type: 'error' });
    } finally {
      form.isSaving.value = false;
    }
  };

  const handleSaveDraft = async () => {
    if (!form.title.value.trim() || form.isSaving.value) return;

    form.isSaving.value = true;
    try {
      await notificationApi.createNotification(form.buildPayload(true));
      form.toast.showSuccessToast({ title: 'Rascunho salvo com sucesso', type: 'success' });
      emit('notification-created');
      form.handleClose();
    } catch {
      form.toast.showErrorToast({ title: 'Erro ao salvar rascunho', type: 'error' });
    } finally {
      form.isSaving.value = false;
    }
  };

  return { ...form, handleSave, handleSaveDraft };
}
